import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './ConnectWalletSheet.tokens';

const textBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    color: currentColor;
    letter-spacing: -0.02em;
`;

///
/// Connection Error

export const StyledConnectionError = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    display: grid;
    gap: ${tokens.error.spacing}px;
    margin-top: ${tokens.error.marginTop}px;
    padding: ${tokens.error.spacing}px;
    text-align: center;
    color: ${designColor.red};
    background-color: rgb(255, 0, 0, 0.06);
    border: 1px solid currentColor;
    border-radius: ${tokens.error.spacing}px;
`;

export const ErrorTitle = styled.p`
    ${textBase};
    font-size: ${tokens.error.titleSize}px;
    font-weight: 700;
`;

export const ErrorMessage = styled.p`
    ${textBase};
    font-size: ${tokens.error.messageSize}px;
    line-height: 1.2;
`;

///
/// Footer

export const FooterInterior = styled.div`
    display: grid;
    justify-content: center;
    justify-items: center;
    gap: ${tokens.footer.gap}px;
`;

export const CreateWalletLink = styled(RouterLink)`
    ${styledReset.link};
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};

    display: block;
    padding: ${tokens.createWalletLink.padding}px;
    font-size: ${tokens.createWalletLink.fontSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
    border-radius: ${tokens.createWalletLink.radius}px;
    color: rgba(255, 255, 255, 0.5);
    background-color: transparent;
    transition-property: color, background-color;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &:focus,
    &:hover {
        color: rgb(255, 255, 255, 0.8);
        background-color: rgb(255, 255, 255, 0.1);
    }

    &:active {
        color: rgb(255, 255, 255, 0.6);
        background-color: rgb(255, 255, 255, 0.06);
    }
`;
